<template>
    <div class="carousal-container">
        <el-carousel :interval="50000" class="hide-arrows">
            <el-carousel-item v-for="(item, index) in images" :key="index">
                <div class="image-wrapper">
                    <img :src="item" alt="" @error="handleImageError(index)" />
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import img1 from '../../assets/carsoulimgs/image1.png';
import img2 from '../../assets/carsoulimgs/image2.png';
import img3 from '../../assets/carsoulimgs/image3.png';
import { blobUrl } from "../../../../constants";
import { ref } from 'vue';
import { solarCalculatorStore } from "../../../store/solarCalculator";

export default {
  setup () {
    const store = solarCalculatorStore();
    const calculatorData = store.CALCULATOR_DATA_STATE;
    const fallbackImages = [
      img1,
      img2,
      img3
    ];
    const images = ref([]);
    
    const getImages = async () => {
      const baseImages = !calculatorData.isTata 
        ? [
          blobUrl + calculatorData.orgName + "_slider1.jpg",
          blobUrl + calculatorData.orgName + "_slider2.jpg",
          blobUrl + calculatorData.orgName + "_slider3.jpg"
        ]
        : [
          blobUrl + "tata_slider1.jpg",
          blobUrl + "tata_slider2.jpg",
          blobUrl + "tata_slider3.jpg"
        ];

      const loadedImages = [];
      for (let i = 0; i < baseImages.length; i++) {
        try {
          // Try to fetch the image
          const response = await fetch(baseImages[i]);
          if (response.ok) {
            loadedImages.push(baseImages[i]);
          } else {
            // If image fails to load, use fallback
            loadedImages.push(fallbackImages[i]);
          }
        } catch (error) {
          // If there's any error, use fallback
          loadedImages.push(fallbackImages[i]);
        }
      }
      images.value = loadedImages;
    };

    // Initialize images when component mounts
    getImages();

    const handleImageError = (index) => {
      // If an image fails to load, replace it with fallback
      images.value[index] = fallbackImages[index];
    };

    return {
      calculatorData,
      images,
      handleImageError
    };
  }
}
</script>

<style scoped>
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .carousal-container>>> .el-carousel__container{
      height:90vh !important;
  }

  .image-wrapper {
    height:100%;
    width:100%;
  }

  .image-wrapper img {
    height:100%;
    width:100%;
    object-fit: fill;
  }

@media (max-width: 1180px) {
    .carousal-container>>> .el-carousel__container{
      height:400px !important;
    }
}

@media (max-width: 740px) {
    .carousal-container>>>  .el-carousel__container{
      height:200px !important;

    }
  }
</style>